
"use client";

import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Logo } from './icons';

export function PreLoadingScreen() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="fixed inset-0 z-[200] flex flex-col items-center justify-center bg-background p-4"
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
          >
            <Logo className="h-32 w-auto" />
          </motion.div>
          <motion.div
            initial={{ width: 0 }}
            animate={{ width: '10rem' }}
            transition={{ duration: 1, delay: 0.3, ease: 'easeInOut' }}
            className="h-1 mt-4 rounded-full bg-primary"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
